import { designService } from '@paragon/data-connections';
import { loadProjectsAndComponentDesignSummaryLayoutModels } from '@paragon/layout-models';
import { enqueueError } from '@paragon/notification-tools';

import { AsyncThunkActionVoid } from './thunkActions';

export function loadProjects(): AsyncThunkActionVoid {
  return async function loadProjectsThunkAction(dispatch) {
    try {
      const projects = await designService.projects.fetchProjectsWhichHaveProductionGroups();

      // Load the layout models so we can synchronize them
      dispatch(loadProjectsAndComponentDesignSummaryLayoutModels(projects));
    } catch (error) {
      console.error(error);
      dispatch(enqueueError('Error loading project(s).'));
    }
  };
}
